import React from 'react';
import { Main } from '@src/components/main';

export const App = () => (
  <div>
    <Main></Main>
  </div>
);
